module.exports = __webpack_public_path__ + "img/tg.262f1ce3.svg";